export function convert24HourTo12Hour(time: string) {
  const hours = parseInt(time.split(":")[0])
  const minutes = time.split(":")[1]
  return `${hours > 12 ? hours - 12 : hours}:${minutes} ${hours >= 12 ? "PM" : "AM"}`
}
